import { CaretLeftIcon, CaretRightIcon } from '#icons';
import { ThemeOptions } from '@mui/material';

/**
 * View Pagination props and classes at https://mui.com/material-ui/api/pagination/#css
 */
export const pagination: ThemeOptions['components'] = {
  MuiPagination: {
    defaultProps: {
      // MUI requires this external option name; keep it out of local symbol names.
      ['shape']: 'rounded',
      color: 'primary',
    },
  },
  MuiPaginationItem: {
    defaultProps: {
      slots: {
        previous: CaretLeftIcon,
        next: CaretRightIcon,
      },
    },
  },
};
